import { PaperReferralApprovalResult } from '@dreryk/egabinet-referral-frontend-api';
import { VisitReferralToHospitalApproveCommand } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { PromiseVoidFunction } from '@dreryk/react-common';

import { useReferralPrintCommandSuccessHandler } from '../../shared/useReferralPrintCommandSuccessHandler';
import { ReferralToHospitalFormBean } from '../ReferralToHsopitalForm/ReferralToHospitalForm.types';

import { mapReferralToHospitalFormBeanToReferralCommandDetails } from './ReferralToHospitalSendAction.utils';

export const useReferralToHospitalConfirmAndPrintCommand = (
   visitId: number,
   onSuccess: PromiseVoidFunction
): UseCqrsCommandResult<PaperReferralApprovalResult, ReferralToHospitalFormBean> => {
   const handleSuccess = useReferralPrintCommandSuccessHandler({
      visitId: visitId,
      onPrintDone: onSuccess,
   });
   return useCqrsCommand<PaperReferralApprovalResult, ReferralToHospitalFormBean>(
      (parameters) => {
         const command = new VisitReferralToHospitalApproveCommand();
         command.visitId = visitId;
         command.referralDetails = mapReferralToHospitalFormBeanToReferralCommandDetails(parameters, false);
         return command;
      },
      {
         onSuccess: handleSuccess,
      }
   );
};
